import { Check, ChevronRight, LogOut, ShieldCheck } from "lucide-react";
import type { Owner } from "../types";
import type { View } from "./views";
import Avatar from "../components/Avatar";
import Modal from "../components/Modal";
import { useProfileNames } from "../components/ProfilesContext";

// Switching between household profiles, and signing out. Profiles organise the app rather
// than wall anything off — either person can see everything — so this is a convenience, not a
// security boundary.

export interface ProfileMenuProps {
  profile: Owner | null;
  owner: Owner | "All";
  view: View;
  switchProfile: (profile: Owner) => void;
  logout: (everywhere?: boolean) => void;
  setProfileMenu: (open: boolean) => void;
}

export default function ProfileMenu({ profile, switchProfile, logout, setProfileMenu }: ProfileMenuProps) {
  const names = useProfileNames();
  return (
    <Modal
      title="Make yourself at home"
      onClose={() => setProfileMenu(false)}
    >
      <p className="muted">
        Your profile sets the default view. Everyone can see the whole
        household.
      </p>
      <div className="switch-profiles">
        {names.map((p) => (
          <button key={p} onClick={() => switchProfile(p)}>
            <Avatar owner={p} />
            <span>
              {p}
              <small>
                {p === profile ? "Your current profile" : "Switch profile"}
              </small>
            </span>
            {p === profile ? (
              <Check size={20} />
            ) : (
              <ChevronRight size={20} />
            )}
          </button>
        ))}
      </div>
      <div className="session-note">
        <ShieldCheck size={19} />
        <p>
          You’re remembered on this device.
          <small>90 days, renewed while you use Barnyard.</small>
        </p>
      </div>
      <button className="logout-button" onClick={() => logout()}>
        <LogOut size={18} /> Lock & sign out
      </button>
      <button className="logout-button" onClick={() => logout(true)}>
        <LogOut size={18} /> Sign out on every device
      </button>
    </Modal>
  );
}
